import { render } from "./InputPhone.vue?vue&type=template&id=14faa0b3&scoped=true"
import script from "./InputPhone.vue?vue&type=script&lang=js"
export * from "./InputPhone.vue?vue&type=script&lang=js"

import "./InputPhone.vue?vue&type=style&index=0&id=14faa0b3&lang=scss&scoped=true"

import exportComponent from "/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14faa0b3"]])

export default __exports__